import { tokens } from '@/lib/tokens.js';

interface NavItem {
  label: string;
  href: string;
  icon?: string;
}

const NAV_ITEMS: readonly NavItem[] = [
  { label: 'Catálogo', href: '/catalog' },
  { label: 'Favoritos', href: '/catalog?favorites=true' },
  { label: 'Dashboards', href: '/catalog?kind=dashboard' },
] as const;

const ADMIN_ITEMS: readonly NavItem[] = [{ label: 'Administración', href: '/admin' }] as const;

interface SidebarProps {
  currentPath?: string;
}

export function Sidebar({ currentPath = '/' }: SidebarProps) {
  return (
    <nav
      aria-label="Navegación principal"
      style={{
        width: '240px',
        flexShrink: 0,
        backgroundColor: tokens.colors.bgCardDark,
        borderRight: `1px solid ${tokens.colors.borderDark}`,
        display: 'flex',
        flexDirection: 'column',
        padding: '1rem 0',
        overflowY: 'auto',
      }}
    >
      <ul style={{ listStyle: 'none', margin: 0, padding: '0 0.75rem', flexGrow: 1 }}>
        {NAV_ITEMS.map((item) => (
          <li key={item.href}>
            <a
              href={item.href}
              aria-current={currentPath === item.href ? 'page' : undefined}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.5rem 0.75rem',
                borderRadius: tokens.radius.button,
                color:
                  currentPath === item.href ? tokens.colors.textDark : tokens.colors.textMutedDark,
                backgroundColor:
                  currentPath === item.href ? `${tokens.colors.primary}20` : 'transparent',
                textDecoration: 'none',
                fontSize: '0.875rem',
                fontWeight: currentPath === item.href ? 600 : 400,
                transition: 'all 0.2s',
                borderLeft:
                  currentPath === item.href
                    ? `2px solid ${tokens.colors.primary}`
                    : '2px solid transparent',
              }}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>

      <ul
        style={{
          listStyle: 'none',
          margin: 0,
          padding: '0 0.75rem',
          borderTop: `1px solid ${tokens.colors.borderDark}`,
          paddingTop: '0.75rem',
          marginTop: '0.75rem',
        }}
      >
        {ADMIN_ITEMS.map((item) => (
          <li key={item.href}>
            <a
              href={item.href}
              aria-current={currentPath === item.href ? 'page' : undefined}
              style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem',
                padding: '0.5rem 0.75rem',
                borderRadius: tokens.radius.button,
                color: tokens.colors.textMutedDark,
                textDecoration: 'none',
                fontSize: '0.875rem',
                transition: 'all 0.2s',
              }}
            >
              {item.label}
            </a>
          </li>
        ))}
      </ul>
    </nav>
  );
}
